'use client';
import Script from 'next/script';

import { env } from '../../env';

const SKYBEAM_PIXEL_SNIPPET = `
  (function(e,n,t){e["$$d2cxFn"]=t;e[t]=e[t]||function(){(e[t].q=e[t].q||[]).push(arguments)};var c=n.getElementsByTagName("script")[0],o=n.createElement("script");o.async=true;o.src="https://analytics-sm.com/js/v1/beacon.js";c.parentNode.insertBefore(o,c)})(window,document,"sm_beacon");
  sm_beacon('setup', 'beacon', '09843a95-e60c-4422-9a74-1b070fc8b62c');
  sm_beacon('setup', 'user_tracking', true);
  sm_beacon('send', 'pageview');
`;

const SKYBEAM_ANALYTICS_SNIPPET = `
  (function(e,n,t){e["$$sbFn"]=t;e[t]=e[t]||function(){(e[t].q=e[t].q||[]).push(arguments)};var c=n.getElementsByTagName("script")[0],o=n.createElement("script");o.async=true;o.src="https://www.skybeam-analytics.com/js/v1/beacon.js";c.parentNode.insertBefore(o,c)})(window,document,"sb_beacon");
  sb_beacon('setup', 'beacon', '755bc7f8-d1dc-41de-8b10-818a28c74a43');
  sb_beacon('setup', 'user_tracking', true);
  sb_beacon('send', 'pageview');
`;

const buildSkybeamExtraSnippet = (beaconUrl: string) => `
  (function(e,n,t){
    e["$$sbFn"]=t;
    e[t]=e[t]||function(){(e[t].q=e[t].q||[]).push(arguments)};
    var c=n.getElementsByTagName("script")[0],
    o=n.createElement("script");
    o.async=true;
    o.src="${beaconUrl}";
    c.parentNode.insertBefore(o,c);
  })(window,document,"sb_beacon");
  sb_beacon('setup', 'beacon', '3269e439-e438-4296-95aa-df3b18609847');
  sb_beacon('setup', 'user_tracking', true);
  sb_beacon('send', 'pageview');
`;

export default function SkybeamPixels() {
  const snippets: string[] = [];
  const isProduction = process.env.NODE_ENV === 'production';

  if (isProduction) {
    snippets.push(SKYBEAM_PIXEL_SNIPPET, SKYBEAM_ANALYTICS_SNIPPET);
  }

  if (env.NEXT_PUBLIC_BEACON_URL) {
    snippets.push(buildSkybeamExtraSnippet(env.NEXT_PUBLIC_BEACON_URL));
  }

  if (snippets.length === 0) {
    return null;
  }

  return (
    <Script id="skybeam-pixels" strategy="afterInteractive">
      {snippets.join('\n')}
    </Script>
  );
}
